import script from "./AppointmentModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentModule.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentModule.vue?vue&type=style&index=0&id=0e1e5bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1e5bfa"]])

export default __exports__